// import AdminLayout from "../../../Layout/AdminLayout";
import CreateFineSetting from "./modules/CreateFineSetting";
import { useGetFineCategoriesQuery } from "../../../store/admin/settings/fineSlice";
import { useLocation } from "react-router-dom";

const NewFine = () => {
  const { data, isLoading } = useGetFineCategoriesQuery();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialCategoryId = queryParams.get("category_id");
  const initialCategoryName = queryParams.get("category_name");

  return (
    <section className="px-2 px-lg-4 min-vh-100 rounded-4">
      <CreateFineSetting 
        categories={data} 
        isLoading={isLoading} 
        initialCategoryId={initialCategoryId}
        initialCategoryName={initialCategoryName}
      />
    </section>
  );
};

export default NewFine;
